export enum WidgetType {
  Card = "CARD",
  Line = "LINE",
  Bar = "BAR",
  Pie = "PIE",
  Table = "TABLE",
}

export const widgetTypeList = [
  { value: WidgetType.Card, label: "Card" },
  { value: WidgetType.Line, label: "Line" },
  { value: WidgetType.Bar, label: "Bar" },
  { value: WidgetType.Pie, label: "Pie" },
  { value: WidgetType.Table, label: "Table" },
];

export const getWidgetTypeLabel = (type: WidgetType) => {
  return widgetTypeList.find((item) => item.value === type)?.label;
};